import api from "../../../app/api";
import {BundleType} from "../billing-and-plans/BundlesList";

export interface OrderForm {
  firstName: string;
  lastName: string;
  street: string;
  city: string;
  country: string;
  state: string;
  zip: string;
  phone: string;
  bundle_id: number;
  type: BundleType;
}

export async function calculatePriceBreakdown(id: string|number) {
  return await api.get(`/order/calculate-price-breakdown?id=${id}`);
}

export async function processOrder(item: OrderForm) {
  return await api.post("/order/create", { OrderForm: item });
}